var site = site || {};
site.spp = site.spp || {};
site.spp.data = site.spp.data || {};
var POWERREVIEWS = POWERREVIEWS || {};
(function($) {
  var pr_products = [];
  // Jo Malone CA FR Config Changes.
  var prLocale = document.location.hostname.search('fr.jomalone.ca') !== -1 || document.location.hostname.search('elc.onelink-translations.com') !== -1 ? Drupal.settings.power_reviews.locale_fr : Drupal.settings.power_reviews.locale;
  var prMerchantId = document.location.hostname.search('fr.jomalone.ca') !== -1 || document.location.hostname.search('elc.onelink-translations.com') !== -1 ? Drupal.settings.power_reviews.merchant_id_fr : Drupal.settings.power_reviews.merchant_id;

  // Set up PowerReviews data on product.init
  $(document).on('product.init-pr', function() {
    pr_products = [];

    if (POWERREVIEWS && typeof Drupal.settings.power_reviews !== 'undefined') {
      //For SPP Page
      if (typeof $('.module-spp-detail').data('productid') !== 'undefined' || typeof $('.spp-product').data('productid') !== 'undefined'
          || typeof $('.sd-product-spp').data('product-id') !== 'undefined') {
        var product_id = $('.module-spp-detail').data('productid') || $('.spp-product').data('productid');
        var product_base_id = typeof product_id !== 'undefined' ? product_id.substring(4) : $('.sd-product-spp').data('product-id');
        var page_id = Drupal.settings.power_reviews.page_id || product_base_id;
        var review_wrapper_url = (Drupal.settings.power_reviews.review_wrapper_url || '/review/create') + '?pr_page_id=' + page_id;
        var pr_product = {
          api_key: Drupal.settings.power_reviews.api_key,
          locale: prLocale,
          merchant_group_id: Drupal.settings.power_reviews.merchant_group_id,
          merchant_id: prMerchantId,
          page_id: page_id,
          review_wrapper_url: review_wrapper_url,
          REVIEW_DISPLAY_SNAPSHOT_TYPE: 'SIMPLE',
          components: {
            ReviewDisplay: 'pr-review-display'
          }
        };
        if ($('#pr-spp-snippet').length) {
          pr_product.components.ReviewSnippet = 'pr-spp-snippet';
        }
        pr_product.on_read_reviews_click = function() {
          $(document).trigger('anchor-review');
          $('.js-pr-rating-tab', $('.responsive-tabs--powerreviews')).trigger('click');
          if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
            site.track.reviewRead();
          }
        };
        pr_product.on_write_review_click = function(config, data) {
          var war_link = $('.pr-snippet-write-review-link').attr('href');
          if (typeof war_link !== 'undefined' && war_link !== '') {
            window.location.href = war_link;
          }
        };
        var product = typeof site.spp.data.product !== 'undefined' ? site.spp.data.product : '';
        if (product !== '') {
          pr_product.on_render = function(config, data) {
            if (config.component === 'ReviewDisplay') {
              if (!$('#pr-review-snapshot').hasClass('pr-snapshot-mobile')) {
                $('.pr-rd-review-header-sorts').insertBefore('.pr-rd-main-header-search');
              } else {
                $('.pr-review-snapshot-block-histogram', $('.pr-review-snapshot-simple')).append($('.pr-snippet-write-review-link', $('.pr-review-snapshot-block-snippet')));
              }
              $('.pr-review-snapshot-block-recommend').insertBefore('.pr-review-snapshot-block-snippet');
            }
          };
          var image_url = typeof product.IMAGE_SPP === 'object' ? product.IMAGE_SPP[0] : product.IMAGE_SPP;
          var url = encodeURI(product.url);
          var base_url = window.location.protocol + '//' + document.location.hostname;

          pr_product.strip_html_tags = function(str) {
            if ((str === null) || (str === '')) {
              return false;
            } else {
              str = str.toString();
              return str.replace(/<[^>]*>/g, '');
            }
          };

          pr_product.product = {
            name: pr_product.strip_html_tags(product.PROD_RGN_NAME),
            url: base_url + url,
            image_url: base_url + image_url,
            description: pr_product.strip_html_tags(product.DESCRIPTION),
            category_name: product.DEFAULT_CAT_ID,
            upc: product.skus[0].UPC_CODE,
            brand_name: 'Clinique',
            price: product.skus[0].PRICE,
            in_stock: (!!product.isShoppable).toString()
          };
        }
        pr_products.push(pr_product);
      }
      if (Drupal.settings.power_reviews.show_ask_question && ($('.module-spp-detail').length && $('.js-product').length) && !$('#pr-questionsnippet').hasClass('question-processed')) {
        $('#pr-questionsnippet').addClass('question-processed');
        $('.js-pr-ask-tab').removeClass('hidden');

        var pr_product_question = {
          api_key: Drupal.settings.power_reviews.api_key,
          locale: prLocale,
          merchant_group_id: Drupal.settings.power_reviews.merchant_group_id,
          merchant_id: prMerchantId,
          page_id: page_id,
          review_wrapper_url: review_wrapper_url,
          on_render: function(config, data) {
            var question_count = data.question_count;
            if (question_count > 0) {
              $('.pr-ask-question-link').addClass('hidden');
              if (!$('.pr-snippet-qa-answer-link').hasClass('count-rendered')) {
                $('.pr-snippet-qa-answer-link').append(' ' + question_count);
                $('.pr-snippet-qa-answer-link').addClass('count-rendered');
              }
            } else {
              $('.pr-snippet-qa-metrics').addClass('hidden');
            }
          },
          on_view_answers_click: function() {
            $('.js-pr-ask-tab').trigger('click');
            $('html, body').animate({
              'scrollTop': $('.tabs-nav').offset().top
            }, 1000);
          },
          on_ask_question_click: function() {
            $('.js-pr-ask-tab').trigger('click');
            var headerHeight = $('#top_wrapper').height();
            $('html, body').animate({
              'scrollTop': $('#pr-questiondisplay').offset().top - headerHeight
            }, 1000);
          },
          components: {
            QuestionSnippet: 'pr-questionsnippet',
            QuestionDisplay: 'pr-questiondisplay',
          }
        };
        pr_products.push(pr_product_question);
      }
    }

    $('div.reviews').find('div#pr-questionsnippet').appendTo('div.reviews');
  });

  $(document).on('click', '.js-read-reviews-link', function() {
    if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
      site.track.reviewRead();
    }
  });

  $(document).on('click', '.pr-snippet-write-review-link', function() {
    if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
      site.track.reviewWriteStart();
    }
  });

  $(document).on('change', '#pr-rd-sort-by', function() {
    if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
      site.track.sortReviews({ sort_option: this.value });
    }
  });

  $(document).on('click', '.pr-helpful-yes', function() {
    if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
      site.track.rateReviews({ event_action: 'thumbs up' });
    }
  });

  $(document).on('click', '.pr-helpful-no', function() {
    if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
      site.track.rateReviews({ event_action: 'thumbs down' });
    }
  });

  $(document).on('click', '.pr-rd-flag-review-container', function() {
    if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
      site.track.rateReviews({ event_action: 'flag this review' });
    }
  });

  $(document).on('anchor-review', function() {
    $('.js-pr-rating-tab').trigger('click');
    if (Drupal.settings.power_reviews.show_ask_question) {
      $('html, body').animate({
        'scrollTop': $('.tabs-nav').offset().top - 150
      }, 1000);
    } else {
      $('html, body').animate({
        'scrollTop': $('#pr-review-display').offset().top - 150
      }, 1000);
    }
  });

  $(document).on('write-review', function() {
    if (typeof $('.module-spp-detail').data('productid') !== 'undefined' || typeof $('.spp-product').data('productid') !== 'undefined') {
      var product_id = $('.module-spp-detail').data('productid') || $('.spp-product').data('productid');
      var product_base_id = product_id.substring(4);
      var page_id = Drupal.settings.power_reviews.page_id || product_base_id;
      var review_wrapper_url = (Drupal.settings.power_reviews.review_wrapper_url || '/review/create') + '?pr_page_id=' + page_id;
      location.href = review_wrapper_url;
    }
  });

  $(document).ready(function() {
    var hash = location.hash;
    if (hash.indexOf('write_review') >= 0) {
      $(document).trigger('write-review');
    } else if (hash.indexOf('review') >= 0) {
      $(document).trigger('anchor-review');
    }
  });

  $('ul.tabs-nav li').on('click', function() {
    var tab_id = $(this).attr('data-tab');
    $('.tabs-content').hide();
    $('ul.tabs-nav li').removeClass('tab-active');
    $('.' + tab_id).show();
    $(this).addClass('tab-active');
  });
})(jQuery);
